import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, ValidationMessageType, SettingState,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class Tibbit_44_1 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_44_1';
        this.name = 'Tibbit 44_1';
        this.capabilities = ['serial'];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                required: true,
                default: '',
            },
            {
                id: 'MODE',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: 'RS232',
                options: [
                    {
                        name: 'RS232',
                        value: 'RS232',
                    },
                    {
                        name: 'RS422',
                        value: 'RS422',
                    },
                    {
                        name: 'RS485',
                        value: 'RS485',
                    },
                ],
            },
            {
                id: 'BAUD',
                name: 'Baud Rate',
                settingType: SettingType.OPTION,
                required: true,
                default: '9600',
                linkToSetting: true,
                options: [
                    {
                        name: '1200',
                        value: '1200',
                    },
                    {
                        name: '2400',
                        value: '2400',
                    },
                    {
                        name: '4800',
                        value: '4800',
                    },
                    {
                        name: '9600',
                        value: '9600',
                    },
                    {
                        name: '19200',
                        value: '19200',
                    },
                    {
                        name: '38400',
                        value: '38400',
                    },
                    {
                        name: '57600',
                        value: '57600',
                    },
                    {
                        name: '115200',
                        value: '115200',
                    },
                    {
                        name: '230400',
                        value: '230400',
                    },
                    {
                        name: '460800',
                        value: '460800',
                    },
                    {
                        name: '921600',
                        value: '921600',
                    },
                ],
                setting: {
                    SETTINGID: 'BAUD',
                    NAME: 'Baud Rate',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 0,
                    MAX: 8,
                    DEFAULT: '9600',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: '1200',
                            value: '1200',
                        },
                        {
                            name: '2400',
                            value: '2400',
                        },
                        {
                            name: '4800',
                            value: '4800',
                        },
                        {
                            name: '9600',
                            value: '9600',
                        },
                        {
                            name: '19200',
                            value: '19200',
                        },
                        {
                            name: '38400',
                            value: '38400',
                        },
                        {
                            name: '57600',
                            value: '57600',
                        },
                        {
                            name: '115200',
                            value: '115200',
                        },
                        {
                            name: '230400',
                            value: '230400',
                        },
                        {
                            name: '460800',
                            value: '460800',
                        },
                        {
                            name: '921600',
                            value: '921600',
                        },
                    ],
                },
            },
            {
                id: 'FLOWCONTROL',
                name: 'Flow Control',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                linkToSetting: true,
                options: [
                    {
                        name: 'disabled',
                        value: '0',
                    },
                    {
                        name: 'RTSCTS',
                        value: '1',
                    },
                    {
                        name: 'XONOFF',
                        value: '2',
                    },
                ],
                setting: {
                    SETTINGID: 'FLOWCTRL',
                    NAME: 'Flow Control',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'disabled',
                            value: '0',
                        },
                        {
                            name: 'RTSCTS',
                            value: '1',
                        },
                        {
                            name: 'XONOFF',
                            value: '2',
                        },
                    ],
                },
            },
            {
                id: 'PARITY',
                name: 'Parity',
                settingType: SettingType.OPTION,
                required: true,
                linkToSetting: true,
                default: '0',
                options: [
                    {
                        name: 'None',
                        value: '0',
                    },
                    {
                        name: 'Even',
                        value: '1',
                    },
                    {
                        name: 'Odd',
                        value: '2',
                    },
                    {
                        name: 'Mark (Always 1)',
                        value: '3',
                    },
                    {
                        name: 'Space (Always 0)',
                        value: '4',
                    },
                ],
                setting: {
                    SETTINGID: 'PARITY',
                    NAME: 'Parity',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'None',
                            value: '0',
                        },
                        {
                            name: 'Even',
                            value: '1',
                        },
                        {
                            name: 'Odd',
                            value: '2',
                        },
                        {
                            name: 'Mark(Always 1)',
                            value: '3',
                        },
                        {
                            name: 'Space(Always 0)',
                            value: '4',
                        },
                    ],
                },
            },
            {
                id: 'BITS',
                name: 'Data Bits',
                settingType: SettingType.OPTION,
                required: true,
                linkToSetting: true,
                default: '1',
                options: [
                    {
                        name: '7 Bits',
                        value: '0',
                    },
                    {
                        name: '8 Bits',
                        value: '1',
                    },
                ],
                setting: {
                    SETTINGID: 'BITS',
                    NAME: 'Data Bits',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '1',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: '7 Bits',
                            value: '0',
                        },
                        {
                            name: '8 Bits',
                            value: '1',
                        },
                    ],
                },
            },
            {
                id: 'TXBUF',
                name: 'TX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
            {
                id: 'RXBUF',
                name: 'RX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        const FLOWCONTROL = this.getSettingValue('FLOWCONTROL');
        if (this.getSettingValue('MODE') === 'RS485') {
            if (FLOWCONTROL !== 'PL_SER_FC_RTSCTS') {
                errors.push({
                    messageType: ValidationMessageType.UPDATE,
                    message: '',
                    featureId: this.getID(),
                    settingId: 'FLOWCONTROL',
                    data: 'PL_SER_FC_RTSCTS',
                });
            }
        }
        return errors;
    }

    getState(settingId: string): SettingState {
        if (settingId === 'FLOWCONTROL') {
            if (this.getSettingValue('MODE') === 'RS485') {
                return SettingState.DISABLED;
            }
        }
        return SettingState.ENABLED;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            const featureId = this.getID();
            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                id: `${featureId}_init_context`,
                template: `
        this.updateContext("${featureId}", {
            buffer: "",
            timestamp: 0,
            type: "",
            routedTo: "",
        })
        `,
            });
            return blocks;
        }

        const neighborSocket = (Number(this.getSettingValue('SOCKET')) + 2).toString();
        const FLOWCONTROL = this.getSettingValue('FLOWCONTROL');
        const serName = `SER_${this.getSettingValue('NAME')}`;
        const NAME = this.getSettingValue('NAME');
        let flowControlMap = '';
        if (FLOWCONTROL === '1') { // RTSCTS
            const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
            const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
            flowControlMap = `
    ser.rtsmap=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.enabled=YES
    ser.ctsmap=${interruptEnum}
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[3]}
    io.enabled=NO`;
        }
        let template = `
    'Tibbit 44_1 ${this.getSettingValue('MODE')} setup on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    ${NAME}=${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}
    ser.num=${serName}
    `;
        switch (this.getSettingValue('MODE')) {
            case 'RS232':
                template += `
    io.num=${Tibbits.getSocketPins(neighborSocket, this.project.device.id)[0]}
    io.enabled=YES
    io.state=HIGH
    io.num=${Tibbits.getSocketPins(neighborSocket, this.project.device.id)[1]}
    io.enabled=YES
    io.state=LOW
    ser.interface=PL_SER_SI_FULLDUPLEX
        `;
                break;
            case 'RS422':
                template += `
    ser.interface=PL_SER_SI_FULLDUPLEX
    io.num=${Tibbits.getSocketPins(neighborSocket, this.project.device.id)[0]}
    io.enabled=YES
    io.state=HIGH
    io.num=${Tibbits.getSocketPins(neighborSocket, this.project.device.id)[1]}
    io.enabled=YES
    io.state=HIGH
        `;
                break;
            case 'RS485':
                template += `
    io.num=${Tibbits.getSocketPins(neighborSocket, this.project.device.id)[0]}
    io.enabled=YES
    io.state=LOW
    io.num=${Tibbits.getSocketPins(neighborSocket, this.project.device.id)[1]}
    io.enabled=YES
    io.state=HIGH
    ser.interface=PL_SER_SI_HALFDUPLEX
        `;
                break;
            default:

                break;
        }

        blocks.push({
            location: 'on_ser_data_arrival',
            blockType: BlockType.CODE,
            template: `
    if ser.num=${serName} then
        'data on serial port ${serName}
    end if
        `,
        });

        template += `
    ${flowControlMap}
    ser.parity=${this.project.convertDataType(this.getSettingValue('PARITY'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.bits=${this.project.convertDataType(this.getSettingValue('BITS'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.flowcontrol=${this.project.convertDataType(this.getSettingValue('FLOWCONTROL'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.baudrate=ser.div9600*9600/${this.project.convertDataType(this.getSettingValue('BAUD'), TibboDataType.STRING, TibboDataType.DWORD)}
    ser.esctype=PL_SER_ET_DISABLED
    ser.interchardelay=0
    ser.txbuffrq(${this.getSettingValue('TXBUF')})
    ser.rxbuffrq(${this.getSettingValue('RXBUF')})
    sys.buffalloc()
    
    ser.enabled=YES
    '-----------------------------------------------------------------
    
        `;
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${serName} = ${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}
const ${this.getSettingValue('NAME')}_TX = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[0]}
const ${this.getSettingValue('NAME')}_RX = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[1]}

            `,
        });


        return blocks;
    }
}
